import { useState } from "react";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import styled from "styled-components";

const PasswordInput = ({ name, placeholder, onChange, className }) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Wrapper>
    <div style={{ position: "relative", width: "100%" }}>
      <input
        type={showPassword ? "text" : "password"}
        name={name}
        placeholder={placeholder}
        onChange={onChange}
        className={className}
        style={{ paddingRight: "45px" }}
      />

      <span
        onClick={() => setShowPassword(!showPassword)}
        style={{
          position: "absolute",
          right: "12px",
          top: "50%",
          transform: "translateY(-50%)",
          cursor: "pointer",
          fontSize: "18px",
          color: "#787878"
        }}
      >
        {showPassword ? <FaEyeSlash /> : <FaEye />}
      </span>
    </div>
    </Wrapper>
  );
};
const Wrapper=styled.div`
`;

export default PasswordInput;